import { apiRequest } from 'api/apiClient';

// Products
const bulkCreateProducts = async ({ region_uid, child_products }) => {
  const response = await apiRequest('POST', '/v1/products/bulk-create', {
    region_uid,
    child_products,
  });
  return response;
};

// Parent Products
const createParentProduct = async ({ name, description, details, region_uid, category_uid }) => {
  const response = await apiRequest('POST', '/v1/parent-products', {
    name,
    description,
    details,
    region_uid,
    category_uid,
  });
  return response;
};

const updateParentProduct = async ({
  uid,
  name,
  description,
  details,
  region_uid,
  category_uid,
}) => {
  const response = await apiRequest('PUT', `/v1/parent-products/${uid}`, {
    name,
    description,
    details,
    region_uid,
    category_uid,
  });
  return response;
};

const deleteParentProduct = async (uid) => {
  const response = await apiRequest('DELETE', `/v1/parent-products/${uid}`);
  return response;
};

// Child Products
const createChildProduct = async ({
  product_code,
  description,
  picture_id,
  parent_product_uid,
  inventory_uid,
  color_uid,
  size_uid,
  price,
}) => {
  const response = await apiRequest('POST', '/v1/child-products', {
    product_code,
    description,
    picture_id,
    parent_product_uid,
    inventory_uid,
    color_uid,
    size_uid,
    price,
  });
  return response;
};

const updateChildProduct = async ({
  uid,
  product_code,
  description,
  picture_id,
  parent_product_uid,
  inventory_uid,
  color_uid,
  size_uid,
  price,
}) => {
  const response = await apiRequest('PUT', `/v1/child-products/${uid}`, {
    product_code,
    description,
    picture_id,
    parent_product_uid,
    inventory_uid,
    color_uid,
    size_uid,
    price,
  });
  return response;
};

const deleteChildProduct = async (uid) => {
  const response = await apiRequest('DELETE', `/v1/child-products/${uid}`);
  return response;
};

const patchChildProduct = async ({ uid, ...data }) => {
  const response = await apiRequest('PATCH', `/v1/child-products/${uid}`, data);
  return response;
};

// Colors
const createColor = async ({ name, hex_value, region_uid }) => {
  const response = await apiRequest('POST', '/v1/product-colors', {
    name,
    hex_value,
    region_uid,
  });
  return response;
};

const updateColor = async ({ uid, name, hex_value, region_uid }) => {
  const response = await apiRequest('PUT', `/v1/product-colors/${uid}`, {
    name,
    hex_value,
    region_uid,
  });
  return response;
};

const deleteColor = async (uid) => {
  const response = await apiRequest('DELETE', `/v1/product-colors/${uid}`);
  return response;
};

const generateColors = async () => {
  const response = await apiRequest('POST', '/v1/product-colors/generate');
  return response;
};

// Sizes
const createSize = async ({ name, region_uid }) => {
  const response = await apiRequest('POST', '/v1/product-sizes', {
    name,
    region_uid,
  });
  return response;
};

const updateSize = async ({ uid, name, region_uid }) => {
  const response = await apiRequest('PUT', `/v1/product-sizes/${uid}`, {
    name,
    region_uid,
  });
  return response;
};

const deleteSize = async (uid) => {
  const response = await apiRequest('DELETE', `/v1/product-sizes/${uid}`);
  return response;
};

const generateSizes = async () => {
  const response = await apiRequest('POST', '/v1/product-sizes/generate');
  return response;
};

// Categories
const createCategory = async ({ name, region_uid }) => {
  const response = await apiRequest('POST', '/v1/product-categories', {
    name,
    region_uid,
  });
  return response;
};

const updateCategory = async ({ uid, name, region_uid }) => {
  const response = await apiRequest('PUT', `/v1/product-categories/${uid}`, {
    name,
    region_uid,
  });
  return response;
};

const deleteCategory = async (uid) => {
  const response = await apiRequest('DELETE', `/v1/product-categories/${uid}`);
  return response;
};

const generateCategories = async () => {
  const response = await apiRequest('POST', '/v1/product-categories/generate');
  return response;
};

// Inventories
const createInventory = async ({ name, region_uid }) => {
  const response = await apiRequest('POST', '/v1/product-inventories', {
    name,
    region_uid,
  });
  return response;
};

const updateInventory = async ({ uid, name, region_uid }) => {
  const response = await apiRequest('PUT', `/v1/product-inventories/${uid}`, {
    name,
    region_uid,
  });
  return response;
};

const deleteInventory = async (uid) => {
  const response = await apiRequest('DELETE', `/v1/product-inventories/${uid}`);
  return response;
};

const generateInventories = async () => {
  const response = await apiRequest('POST', '/v1/product-inventories/generate');
  return response;
};

// Favorite Products
const addFavoriteProduct = async (uids) => {
  const response = await apiRequest('POST', '/v1/favorite-products', {
    child_product_uids: uids,
  });
  return response;
};

const deleteFavoriteProduct = async (uid) => {
  const response = await apiRequest('DELETE', `/v1/favorite-products/${uid}`);
  return response;
};

const deleteFavoriteProducts = async (uids) => {
  const response = await apiRequest('POST', '/v1/favorite-products/bulk-delete', { uids });
  return response;
};

const moveFavoriteProduct = async ({ uid, before, after }) => {
  const response = await apiRequest('PATCH', `/v1/favorite-products/${uid}/move`, {
    ...(before ? { before } : {}),
    ...(after ? { after } : {}),
  });
  return response;
};

const PRODUCTS_MUTATIONS = {
  // Favorite Products
  ADD_FAVORITE_PRODUCT: addFavoriteProduct,
  DELETE_FAVORITE_PRODUCT: deleteFavoriteProduct,
  DELETE_FAVORITE_PRODUCTS: deleteFavoriteProducts,
  MOVE_FAVORITE_PRODUCT: moveFavoriteProduct,

  // Products
  BULK_CREATE_PRODUCTS: bulkCreateProducts,

  // Parent Products
  CREATE_PARENT_PRODUCT: createParentProduct,
  UPDATE_PARENT_PRODUCT: updateParentProduct,
  DELETE_PARENT_PRODUCT: deleteParentProduct,

  // Child Products
  CREATE_CHILD_PRODUCT: createChildProduct,
  UPDATE_CHILD_PRODUCT: updateChildProduct,
  DELETE_CHILD_PRODUCT: deleteChildProduct,

  PATCH_CHILD_PRODUCT: patchChildProduct,

  // Colors
  CREATE_COLOR: createColor,
  UPDATE_COLOR: updateColor,
  DELETE_COLOR: deleteColor,
  GENERATE_COLORS: generateColors,

  // Sizes
  CREATE_SIZE: createSize,
  UPDATE_SIZE: updateSize,
  DELETE_SIZE: deleteSize,
  GENERATE_SIZES: generateSizes,

  // Categories
  CREATE_CATEGORY: createCategory,
  UPDATE_CATEGORY: updateCategory,
  DELETE_CATEGORY: deleteCategory,
  GENERATE_CATEGORIES: generateCategories,

  // Inventories
  CREATE_INVENTORY: createInventory,
  UPDATE_INVENTORY: updateInventory,
  DELETE_INVENTORY: deleteInventory,
  GENERATE_INVENTORIES: generateInventories,
};

export default PRODUCTS_MUTATIONS;
